import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { emailRegex } from '../../utils/constants';

export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const email = control.value;
    const errors: ValidationErrors = {};

    if (!email) {
      return null;
    }
    if (!emailRegex.test(email)) {
      errors['email'] = true;
      return errors;
    }

    const domain = email.split('@')[1];
    const domainParts = domain.split('.');

    for (let i = 0; i < domainParts.length - 1; i++) {
      if (domainParts[i].length < 1 || domainParts[i].length > 63) {
        errors['domainLength'] = true;
        return errors;
      }
      if (domainParts[i].startsWith('-') || domainParts[i].endsWith('-')) {
        errors['domainHyphen'] = true;
        return errors;
      }
    }

    return null;
  };
}